import tabIconUrl from './header logo.png';

/**
 * The icon in the browser tab is the "header logo" image of src/. public/index.html cannot reference a file of src/ (only the build
 * can give it its final address), so the page's <link rel="icon"> is set here, before the first render.
 */
export const applyTabIcon = (doc = document) => {
  let link = doc.querySelector("link[rel~='icon']");
  if (!link) {
    link = doc.createElement('link');
    link.rel = 'icon';
    doc.head.appendChild(link);
  }
  link.type = 'image/png';
  link.href = tabIconUrl;
};
